<template>
  <div class="payment-wrapper">
    <template v-if="step == 1">
      <v-card>
        <v-card-text>
          <div class="important-text">
            Разполагате с {{ time }} минути, за да завършите резервацията си.
            <br />
            <!--            <template v-if="currency != 'BGN'">-->
            <!--              Можете да платите с карта или PayPal като кликнетe нa жълтия бутон по-долу. <br>-->
            <!--              За плащане с карта натиснете първо жълтия бутон, след това сивия бутон, на който пише "Pay with Debit or Credit Card" или изберете директно вида на вашата карта.-->
            <!--            </template>-->
          </div>

          <div class="mt-4">
            <promo-code-box
              :selected-tickets="selectedTickets"
              :event="event"
              :secret="secret"
              :currency="currency"
              :amount="localAmount"
              @promo-code-applied="updateAmount"
            />
          </div>

          <gateway-list
            :key="refreshGateway"
            :selected-tickets="selectedTickets"
            :event="event"
            :secret="secret"
            :currency="currency"
            :amount="localAmount"
            @step-change="(val) => (this.step = val)"
            @gateway-change="(val) => this.$emit('gateway-change', val)"
          />
        </v-card-text>
      </v-card>
    </template>
    <template v-if="step == 2">
      <payment-error :secret="secret" />
    </template>
    <template v-if="step == 3">
      <payment-success :secret="secret" />
    </template>
  </div>
</template>
<script>
import moment from 'moment'
import PaymentError from './Payments/PaymentError'
import PaymentSuccess from './Payments/PaymentSuccess'
import GatewayList from './Payments/GatewayList'
import PromoCodeBox from './components/PromoCodeBox.vue'

export default {
  props: {
    amount: {
      required: true,
    },
    secret: {
      required: true,
    },
    enableBorika: {
      type: Boolean,
      default: false,
    },
    event: {
      type: Object,
      required: true,
    },
    selectedTickets: {
      type: Array,
      required: true,
    },
  },
  components: {
    PromoCodeBox,
    GatewayList,
    PaymentError,
    PaymentSuccess,
  },
  computed: {
    time() {
      return this.date.format('mm:ss')
    },
    currency() {
      if (JSON.parse(this.event.settings).currency) {
        return JSON.parse(this.event.settings).currency
      }

      return 'EUR'
    },
  },
  data() {
    return {
      step: 1,
      date: moment(60 * 30 * 1000),
      localAmount: 0,
      refreshGateway: 1,
    }
  },
  watch: {
    time: function (val) {
      if (val == '00:00') {
        window.location = '/'
      }
    },
  },
  methods: {
    updateAmount(data) {
      this.localAmount = data.total
      this.refreshGateway++
    },
  },
  mounted: function () {
    setInterval(() => {
      this.date = moment(this.date.subtract(1, 'seconds'))
    }, 1000)

    this.localAmount = this.amount
  },
}
</script>
<style
  scoped
  lang="scss"
>
.important-text {
  text-align: center;
  font-size: 18px;
  border: 2px solid #2c80d554;
  padding: 10px;
  border-radius: 4px;
  background: #faf8ffe8;

  &.error {
    border: 2px solid #f44336;
    background: #fff8f8e8;
    font-weight: bold;
    color: white;
  }

  &.success-box h1 {
    font-size: 24px;
    font-weight: bold;
    color: #4caf50;
    line-height: 36px;
    text-transform: uppercase;

    svg {
      position: relative;
      top: -4px;
    }
  }
}
.red-important {
  font-weight: bold;
  color: crimson;
}
.payment-wrapper {
  max-width: 800px;
  margin: 0 auto;
}
</style>
